export default __webpack_public_path__ + "static/media/walla.18ba78c7.svg";